module.exports = __webpack_public_path__ + "img/05.ff50b098.gif";